module.exports = __webpack_public_path__ + "img/windows.9b14281c.png";